/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 CardContent — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tractie deviation: '&:last-child' paddingBottom 16 (Tractie inset-m) i.p.v. MUI default 24
// (MUI's extra-bottom-padding voor "card kontekst" past niet bij Tractie's symmetrische inset).

export const MuiCardContentLightOverrides = {
  root: {
    padding: 16,
    transition: 'none',
    '&:last-child': {
      paddingBottom: 16,
    },
  },
} as const;

// Dark variant — geen mode-specifieke overrides; spacing modes-agnostisch.
export const MuiCardContentDarkOverrides = {
  ...MuiCardContentLightOverrides,
} as const;
